(function () {
  var SELECTOR = '.product-rating--root[data-scroll-target]';

  var TARGETS = [
    '.okeReviews .oke-is-clickable',
    '[data-oke-widget]',
    '[data-oke-reviews-widget]',
    '.okeReviews-reviews-main',
    '.okeReviews-widget',
    '.oke-w-reviews-main',
  ];

  var SCROLL_CONTAINERS =
    '[data-oke-widget], [data-oke-reviews-widget], [data-oke-container], #okeReviews-reviews-main, .okeReviews-reviews-main, .okeReviews-widget, .oke-w-reviews-main';

  var timer;

  function findTarget(targetId) {
    var byId = targetId && document.getElementById(targetId);
    var ordered = [document.querySelector(TARGETS[0]), byId].concat(
      TARGETS.slice(1).map(function (s) {
        return document.querySelector(s);
      })
    );
    for (var i = 0; i < ordered.length; i++) {
      if (ordered[i]) return ordered[i];
    }
    return null;
  }

  function scrollToTarget(targetEl, trigger) {
    if (!targetEl) return false;

    if (targetEl.classList && targetEl.classList.contains('oke-is-clickable') && targetEl !== trigger) {
      targetEl.click();
    } else if (targetEl.querySelector) {
      var nested = targetEl.querySelector('.oke-is-clickable');
      if (nested && nested !== trigger) nested.click();
    }

    var scrollEl = (targetEl.closest && targetEl.closest(SCROLL_CONTAINERS)) || targetEl;
    scrollEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function jumpToReviews(trigger) {
    clearTimeout(timer);
    var targetId = trigger.dataset.scrollTarget || 'okeReviews-reviews-main';
    var tries = 0;
    (function seek() {
      if (scrollToTarget(findTarget(targetId), trigger) || ++tries > 20) return;
      timer = setTimeout(seek, 150);
    })();
  }

  function bind(trigger) {
    if (trigger.dataset.okeJumpBound === 'true') return;
    trigger.dataset.okeJumpBound = 'true';

    if (trigger.closest('a[href]')) return;

    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('role', 'button');

    trigger.addEventListener('click', function () {
      jumpToReviews(trigger);
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      jumpToReviews(trigger);
    });
  }

  function bindAll() {
    document.querySelectorAll(SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
